export default null;throw new Error("Unable to resolve \"./adler32\" from npm:pngjs@5.0.0/browser.js");